import { FC } from 'react';

import HookFormErrors from '@app/components/HookFormErrors';

import { AddressFormFields, AddressFormNamespaces } from '../Address.constants';
import { VatNumberField } from './VatNumberField';
import { CompanyField } from './CompanyField';
import { AddressFields } from './AddressFields';
import { NameFields } from './NameFields';
import { PhoneField } from './PhoneField';
import { CountryRegionField } from './CountryRegionField';

const AddressForm: FC<{ namespace: string; countryCode?: string }> = ({
  namespace,
}) => {
  return (
    <div data-testid="address-form">
      <HookFormErrors
        fields={Object.values(AddressFormFields)}
        namespace={namespace}
      />

      <NameFields namespace={namespace} />

      <CompanyField namespace={namespace} />

      {namespace !== AddressFormNamespaces.Shipping && (
        <VatNumberField namespace={namespace} />
      )}

      <CountryRegionField namespace={namespace} />

      <AddressFields namespace={namespace} />

      <PhoneField namespace={namespace} />
    </div>
  );
};

export default AddressForm;
